<template>
  <div v-if="viewMode === 'day'" class="bar" :style="barStyle"></div>
</template>

<script>
export default {
  name: "LogworkHourBar",
  props: {
    hours: { type: [Number, Object], required: true },
    viewMode: { type: String, default: 'day' }
  },
  computed: {
    barStyle() {
      const hours = typeof this.hours === "object" ? this.hours.hours : this.hours;
      if (hours == 0) {
        return { width: '100%', backgroundColor: '' };
      }
      if (hours === 8) {
        return { width: '100%', backgroundColor: '#17A896' };
      } else if (hours > 8) {
        return { width: '100%', backgroundColor: '#F03D3E' };
      } else {
        return { width: '100%', backgroundColor: '#F03D3E' };
      }
    }
  }
};
</script>

<style scoped>
.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  transition: width 0.3s ease;
}
</style>
